import styled from 'styled-components';
import CloseButtonIcon from '../../assets/img/close-button.svg?react';

const Button = styled.button`
  padding: 0;
  margin: 0;
  border: none;
  background-color: transparent;
`;

function CloseButton(props) {
  return (
    <Button {...props}>
      <CloseButtonIcon />
    </Button>
  );
}

export { CloseButton };
